import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 560px;
  max-width: 100%;
  max-height: 60vh;
  overflow-y: auto;
`;

export const GrantRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding-bottom: 16px;
  margin-bottom: 8px;
  border-bottom: 1px solid #eef1f5;

  > :first-child {
    flex-grow: 1;
  }

  button.default-submit-button {
    background-color: ${(props) => props.theme.colors.primary} !important;
    color: white !important;
  }
`;

export const ManagerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f0f3f7;

  .MuiIconButton-root {
    color: ${(props) => props.theme.brand.navy};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ManagerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ManagerName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.brand.ink};
`;

export const ManagerEmail = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.brand.soft};
`;

export const GrantedBy = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.brand.soft};
  font-style: italic;
`;
